import * as React from 'react';

import { ItemTableData, ItemTableDataRow } from 'components/ItemTable/ItemTableData';
import { Location } from 'types/location.type';
import { getPropertyTableBodyFields } from './PropertyTableBodyFields';
import { LocationOptionsData } from 'types/types.type';

export default class PropertyTableDataBuilder {
    static build(
        classes: any,
        locations: Location[],
        locationOptions: LocationOptionsData,
        handleChange: (value: string, id: string) => void,
        tableData: any,
        readonly: boolean,
        isLocationProRataEndorsement: boolean,
        isLocationRenewal: boolean,
        effectiveDate: string,
        expirationDate?: string
    ): ItemTableData {
        const headerFields = [
            {
                value: 'Location Name',
                style: { textAlign: 'left' } as React.CSSProperties,
            },
            { value: 'Class' },
            { value: 'AOP' },
            { value: 'AOP DED' },
            { value: 'WD' },
            { value: 'WD_DED' },
            { value: 'WHH' },
            { value: 'WHH DED' },
            { value: 'NS' },
            { value: 'NS DED' },
            { value: 'FL' },
            { value: 'FL LIMIT' },
            { value: 'FL DED' },
            { value: 'EQ' },
            { value: 'EQ LIMIT' },
            { value: 'EQ DED' },
            { value: 'Zone Id' },
            { value: 'Exp Base Rate', isHidden: readonly || !isLocationRenewal },
            { value: 'Exp CR/DB', isHidden: readonly || !isLocationRenewal },
            { value: 'Exp Final Rate', isHidden: readonly || !isLocationRenewal },
            { value: 'Base Rate' },
            { value: 'CR/DB' },
            { value: 'Final Rate' },
            { value: 'TIV' },
            { value: 'Premium' },
            { value: 'TRIA' },
            { value: isLocationProRataEndorsement ? 'Annualized Premium' : 'Total Premium' },
            {
                value: 'Endorsement Premium',
                isHidden: !isLocationProRataEndorsement,
            },
            { value: 'Insp' },
            { value: 'Lumen Rating' },
        ].filter((r) => !r.isHidden);

        return {
            header: {
                key: 'propertyReviewHeader',
                fields: headerFields,
            },
            body: locations
                .map((location) => {
                    const matchingRowData =
                        tableData.find((entry: any) => entry && entry.rowId.toString() === location.id.toString()) ||
                        null;
                    // The below test will in effect filter out all locations that don't have matching data IF
                    // A. we are not readonly (underwriting), but the location is deleted, so defaults for all non deleted
                    // B. we are readonly, no matching data after underwriting wouldn't make sense to show defaults

                    // If we are not readonly we don't want to show any markedAsDeleted locations
                    // If we are readonly we don't want to show locations without matchingRowData
                    if ((!readonly && location.markedAsDeleted) || (readonly && !matchingRowData)) {
                        return {} as ItemTableDataRow;
                    }
                    return {
                        key: location.id.toString(),
                        fields: getPropertyTableBodyFields({
                            location,
                            locationOptions,
                            matchingRowData: matchingRowData || {},
                            classes,
                            readonly,
                            isLocationRenewal: isLocationRenewal,
                            isLocationProrataEndorsement: isLocationProRataEndorsement,
                            handleChange,
                            effectiveDate,
                            expirationDate,
                        }),
                        markedAsDeleted: location.markedAsDeleted,
                    } as ItemTableDataRow;
                })
                .filter((l) => !!l.key), // filter out any object that has no data, see above
        };
    }
}
